












































































import Vue from 'vue';
import { API } from '@/api';
import { mapActions } from 'vuex';

export default Vue.extend({
  data: () => ({
    menuDate: false,
    openDialog: false,
    date: '',
    formatoFecha: 'DD/MM/YYYY',
    cuentasBancarias: [],
    ingreso: {
      fecha: '',
      monto: '',
      ref: '',
      cuenta: {},
    },
    options: {page: 1, itemsPerPage: 100000, sortBy: 0},
    addUnidad: false,
    unidades: [],
    selectUnidad: {},
  }),
  // mounted() {
  //   this.getData();
  // },
  methods: {
    // ...mapActions(['getCuentasList']),
    async getData() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const result = await this.$store.dispatch('getCuentasList', {admin, condo, options: this.options});
      // this.cuentasBancarias = result.content;
      this.cuentasBancarias = result;
      // console.log('cuentasBancarias: ', result);
    },
    async sendIngreso() {
      if (this.date !== '' && this.ingreso.monto) {
        try {
          this.loading = true;
          const admin = this.$store.getters.getAdmin;
          const condo = this.$store.getters.getCondo;
          this.ingreso.fecha = this.$moment(this.date).format();
          // if (this.selectUnidad.is)
          if (Object.keys(this.selectUnidad).length === 0) {
            // console.log("es null");
            this.ingreso.unidad = null;
          } else {
            this.ingreso.unidad = this.selectUnidad;
            console.log('No es null');
          }
          console.log('Ingreso: ', this.selectUnidad);
          const result = await this.$store.dispatch('addIngreso', {admin, condo, ingreso: this.ingreso});
          // console.log('addIngreso result: %o', result);
          this.$toast.success('Ingreso Agregado exitosamente');
          this.loading = false;
        } catch (e) {
          console.error(e);
          this.$toast.error(e.response.data.message);
        }
        this.openDialog = false;
        this.closeDialog();
        this.$emit('reloadGrid', {});
      } else {
        this.$toast.error('Campos vacios');
      }
    },
    async getUnidades() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const options = this.options;
      const datos = {admin, condo};
      console.log('getUnidades');
      const result = await this.$store.dispatch('getUnidadesPropList', {datos, options});
      this.unidades = result.content;
      console.log('getUnidades: ', result);
    },
    closeDialog() {
      this.openDialog = false;
      this.ingreso = {
        fecha: '',
        monto: '',
        ref: '',
        cuenta: {},
      };
      this.addUnidad = false;
      this.selectUnidad = {};
    },
    restrictChars($event, e) {
      if (/[0-9]/.test(String.fromCharCode($event.charCode)) ||
          ($event.charCode === 46) && (e.indexOf('.') === -1) ) {
        return true;
      } else {
          $event.preventDefault();
      }
    },
  },
  computed: {
    computedDateFormatted() {
      if (this.date === '') {
        return this.date;
      } else {
        return this.$moment(this.date).format(this.formatoFecha);
      }
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.getData();
        this.getUnidades();
        // this.date = this.$moment().format();
      }
    },
  },
});
